module.exports = __webpack_public_path__ + "img/module_pacient.f4726438.jpg";